import NotFound from './not-found';
import Catalog from './catalog';
import { useContext, useState } from 'react';
import { CategoriesContext } from '../../../App';

export enum ViewMode {
    List,
    Tile,
}

function NewItkCatalogWrapper() {
    const { currentCategory } = useContext(CategoriesContext);
    const [viewMode, setViewMode] = useState(ViewMode.Tile);
    if (!currentCategory) {
        return <NotFound>Раздел не найден</NotFound>;
    }
    return (
        <>
            <Catalog viewMode={viewMode} setViewMode={setViewMode} />
        </>
    );
}

export default NewItkCatalogWrapper;
